import { Radio } from "@rmwc/radio";
import { useDispatch, useSelector } from "react-redux";
import { getPricingData, roofStyleChange } from "../../../action";
import { onRoofStyleChange } from "../../../action/building/building_style/buildingStyle.action";

export const RoofStyleSetting = () => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();

	return (
		<div className="form-group">
			<label className="control-label">Roof Style</label>
			{const_var.roof_style.map((val) => {
				return (
					<div className="radio-group">
						<Radio
							onClick={(e) => {
								dispatch(roofStyleChange(e.target.value));
								dispatch(getPricingData(undefined, undefined, "roofstyle"));
								dispatch(onRoofStyleChange(e.target.value));
							}}
							value={val.roof_id}
							label={val.name}
							checked={params.p_r_s == val.roof_id ? true : false}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default RoofStyleSetting;
